/* @flow */
import * as React from 'react';
import Box from 'components/Box';
import BoxFooter from 'components/BoxFooter';
import Button from 'components/Button';
import Container from 'components/Container';
import ParentalConsentCardView from 'user/components/ParentalConsentCardView';
import ParentalConsentSignatureView from 'user/components/ParentalConsentSignatureView';

type Props = {
  childId: Backbone$Id,
  option: string,
  onProceed: Function,
  setOption: Function,
};

class ParentalConsentOptionView extends React.Component<Props> {
  handleChooseDifferentOption = () => {
    this.props.setOption('');
  };

  renderView = () => {
    const { childId, onProceed, option } = this.props;

    if (option === 'card') {
      return <ParentalConsentCardView childId={childId} onProceed={onProceed} />;
    } else {
      return <ParentalConsentSignatureView childId={childId} onProceed={onProceed} />;
    }
  };

  renderFooter = () => {
    const { option } = this.props;

    let differentOptionText;

    if (option === 'card') {
      differentOptionText = 'Prefer to print and sign a permission form?';
    } else if (option === 'signature-file') {
      differentOptionText = 'Prefer to charge a card?';
    }

    return (
      <BoxFooter>
        <Button full level="text" onClick={() => this.handleChooseDifferentOption()}>
          {differentOptionText} Go back
        </Button>
      </BoxFooter>
    );
  };

  render() {
    return (
      <div className="ParentalConsentOptionView">
        <Container size="small">
          <Box>
            {this.renderView()}
            {this.renderFooter()}
          </Box>
        </Container>
      </div>
    );
  }
}

export default ParentalConsentOptionView;
